export const SampleImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
  >
    <path
      d="M5 1C3.89687 1 3 1.89688 3 3V10C3 11.1031 3.89687 12 5 12H16C17.1031 12 18 11.1031 18 10V3C18 1.89688 17.1031 1 16 1H5ZM12.375 4.33437L15.375 8.83438C15.5281 9.06563 15.5438 9.35938 15.4125 9.60312C15.2812 9.84687 15.0281 10 14.75 10H10.25H8.75H6.25C5.9625 10 5.7 9.83437 5.575 9.575C5.45 9.31563 5.48438 9.00625 5.66563 8.78125L7.66563 6.28125C7.80938 6.10313 8.02188 6 8.25 6C8.47812 6 8.69375 6.10313 8.83438 6.28125L9.375 6.95625L11.125 4.33125C11.2656 4.125 11.5 4 11.75 4C12 4 12.2344 4.125 12.375 4.33437ZM6 4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3C7.26522 3 7.51957 3.10536 7.70711 3.29289C7.89464 3.48043 8 3.73478 8 4C8 4.26522 7.89464 4.51957 7.70711 4.70711C7.51957 4.89464 7.26522 5 7 5C6.73478 5 6.48043 4.89464 6.29289 4.70711C6.10536 4.51957 6 4.26522 6 4ZM1.5 3.75C1.5 3.33437 1.16562 3 0.75 3C0.334375 3 0 3.33437 0 3.75V10.75C0 13.0969 1.90313 15 4.25 15H14.25C14.6656 15 15 14.6656 15 14.25C15 13.8344 14.6656 13.5 14.25 13.5H4.25C2.73125 13.5 1.5 12.2688 1.5 10.75V3.75Z"
      fill="#64748B"
    />
  </svg>
);
